import { useContext } from 'react';

import { KycContext } from './context';

export const useKycProvider = () => {
  return useContext(KycContext);
};
